module.exports = __webpack_public_path__ + "img/tmf-logo.eedf3130.webp";